/**
 * Cookie Helper Utilities for DealVoice
 * Securely manages tokens exclusively in cookies.
 */

/**
 * Set a cookie
 * @param {string} name
 * @param {string} value
 * @param {number} days - expiration in days (default 7 days)
 */
export const setCookie = (name, value, days = 7) => {
  const expires = new Date(Date.now() + days * 864e5).toUTCString();
  document.cookie = `${encodeURIComponent(name)}=${encodeURIComponent(value)}; expires=${expires}; path=/; SameSite=Lax`;
};

/**
 * Get cookie value by name
 * @param {string} name
 * @returns {string|null}
 */
export const getCookie = (name) => {
  if (typeof document === "undefined") return null;
  const cookieArr = document.cookie.split("; ");
  const prefix = `${encodeURIComponent(name)}=`;
  for (let cookie of cookieArr) {
    if (cookie.startsWith(prefix)) {
      return decodeURIComponent(cookie.substring(prefix.length));
    }
  }
  return null;
};

/**
 * Remove a cookie
 * @param {string} name
 */
export const removeCookie = (name) => {
  document.cookie = `${encodeURIComponent(name)}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; SameSite=Lax`;
};

/**
 * Get Authorization Token from Cookies
 * Checks "Authorization" cookie, falling back to legacy "token" cookie
 */
export const getAuthToken = () => {
  return getCookie("Authorization") || getCookie("token");
};

/**
 * Save Authorization Token exclusively in Cookie
 */
export const setAuthToken = (token, days = 7) => {
  if (!token) return;
  setCookie("Authorization", token, days);
};

/**
 * Remove Authorization Token from Cookies
 */
export const removeAuthToken = () => {
  removeCookie("Authorization");
  removeCookie("token");
};
